import React from "react";
import { Link } from "react-router-dom";

import { css } from "glamor";

const styles = {
    logo: css({
        maxWidth: "100%",
        maxHeight: "30px",
    }),
};

export default ({ props }) => {
    return (
        <Link to="/">
            <img alt="logo" {...styles.logo} src={props.logo} />
        </Link>
    );
};
